import { Card, ProfilePayoutSection, ProfileSection, PulseLoading } from '..'

import { TPayoutInfo } from '@/libs/types/global.types'

export type TProfileCard = {
  readonly title: string
  readonly isLoading?: boolean
  readonly isShown?: boolean
  readonly contents: TProfileCardContent[]
}

export type TProfileCardContent = {
  readonly isShown?: boolean
  readonly label: string
  readonly value?: string
  readonly isPayout?: boolean
  readonly payoutValue?: TPayoutInfo
  readonly button: {
    disabled?: boolean
    onClick: () => void
  }
  readonly actionType?: 'button' | 'toggle'
  readonly toggle?: {
    disabled?: boolean
    onChange: (state: boolean) => void
    state: boolean
  }
  readonly actionLabel?: string
}

export default function ProfileCard({ title, contents, isLoading, isShown = true }: TProfileCard) {
  const renderContent = (content: TProfileCardContent, index: number) => {
    if (!content.isShown) return null

    if (isLoading)
      return (
        <div className='w-6/12' key={`load-${content.label}-${index}`}>
          <PulseLoading />
        </div>
      )

    if (content?.isPayout)
      return (
        <ProfilePayoutSection
          key={`${content.label}-${index}`}
          label={content.label}
          value={content.payoutValue}
          isLoading={isLoading ?? false}
          disableOnChange={content?.button?.disabled}
          onChange={content?.button?.onClick}
          onToggleChange={content?.toggle?.onChange}
          actionType={content?.actionType}
          toggleState={content?.toggle?.state}
        />
      )

    return (
      <ProfileSection
        key={`${content.label}-${index}`}
        label={content.label}
        value={content.value ?? '-'}
        isLoading={isLoading ?? false}
        disableOnChange={content?.button?.disabled}
        onChange={content?.button?.onClick}
        onToggleChange={content?.toggle?.onChange}
        actionType={content?.actionType}
        toggleState={content?.toggle?.state}
        actionLabel={content?.actionLabel}
      />
    )
  }

  if (!isShown) return null

  return (
    <Card noElevation>
      <div className='flex flex-col gap-6'>
        <div className='flex flex-col gap-1'>
          <h2 className='text-base font-semibold'>{title}</h2>
        </div>
        <hr />
        {contents &&
          contents.length > 0 &&
          contents.map((content, index) => renderContent(content, index))}
      </div>
    </Card>
  )
}
